'use strict';

/* jshint -W098 */
angular.module('mean.tradesman').controller('TradesmanDailyReportController', ['$scope', '$rootScope', '$q', 'Users', 'Global', 'Foreman', 'MeanUser', 'ProjectTasks', '$filter', 'Projects', '$location', 'ProjectHours', 'Builders', 'Holidays', 'tradeCodeService', 'taskListService', 'toaster', 'userService', 'myCoordinates', 'Hours', 'ngDialog', 'timeService',
  function($scope, $rootScope, $q, Users, Global, Foreman, MeanUser, ProjectTasks, $filter, Projects, $location, ProjectHours, Builders, Holidays, tradeCodeService, taskListService, toaster, userService, myCoordinates, Hours, ngDialog, timeService) {
    $scope.global = Global;
    $scope.package = {
      name: 'tradesman'
    };
    $scope.user = MeanUser.user;
    console.log('in tradesman.js for daily reports');
    var start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    var end = new Date();
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);

    $scope.my_trade_code = tradeCodeService.getCode($scope.user.trade[0]);

    $scope.typical = null;

    timeService.getStandardHours($scope.user.trade[0], 
        $scope.user.contractor_code).then(function(typical) {
        $scope.typical = typical;
    });

    $scope.checkMinLunch = function(hour) {
        if($scope.typical.mandatory_lunch) {
            var lunch_start = moment(hour.lunch_start.time);
            var lunch_end = moment();
            var time = moment.duration(lunch_end.diff(lunch_start));
            var minutes = time.hours() * 60;
            minutes += time.minutes();
            if(minutes < $scope.typical.lunch_minimum) {
                toaster.pop('error', 'Cannot Clock Lunch End yet. ',
                    'Mandatory lunch break minimum is ' + $scope.typical.lunch_minimum + 
                    ' minutes not ' + time.minutes() + ' minutes.');
                return false;
            }
        }

        return true;
    };

    $scope.init = function() {
        Hours.query({'start': start,
            'end': end, 
            'type': 'UserDateRange',
            'user': $scope.user._id,
            'trade_code': $scope.my_trade_code,
            'company_code': $scope.user.contractor_code}, function(hours) {
            if(hours.length > 1) {
                toaster.pop('error', 'Clocking Error', 'Contact Admin');
                return;
            } else if(hours.length === 1) {
                _.each(hours, function(hour) {
                    hour.user = hour.user._id;

                    hour.date = new Date(hour.date);
                    if(hour.clock_in)
                      hour.clock_in.time = new Date(hour.clock_in.time);
                    if(hour.lunch_start)
                      hour.lunch_start.time = new Date(hour.lunch_start.time);
                    if(hour.lunch_end)
                      hour.lunch_end.time = new Date(hour.lunch_end.time);
                    if(hour.clock_out)
                      hour.clock_out.time = new Date(hour.clock_out.time);
                });
                $scope.clock_hours = hours[0];
            } else {
                $scope.clock_hours = null;
            }
        });
    };

    $scope.ClockIn = function(user, hour) {
        $scope.clockInClicked = true;
        myCoordinates.get().then(function(coords) {
            if(hour) {
                toaster.pop('error', 'Hours Error', 'Already Clocked In');
                return;
            }

            hour = new Hours({
                user: user._id,
                date: new Date(),
                trade_code: $scope.my_trade_code,
                company_code: $scope.user.contractor_code,
                clock_in: {
                    time: new Date(),
                    code: 'E',
                    location: {
                        lat: coords.lat,
                        lon: coords.lon
                    },
                    ip: coords.ip
                },
            });

            hour.$save(function(success) {
                success.user = success.user._id;
                success.date = new Date(success.date);
                success.clock_in.time = new Date(success.clock_in.time);

                $scope.clock_hours = success;
            });
        });
    };

    $scope.LunchStart = function(user, hour) {
        $scope.lunchStartClicked = true;
        if(!hour) {
                $scope.overrideHoursOperation('lunch_start', user, hour);
        } else {
            myCoordinates.get().then(function(coords) {
                hour.lunch_start = {
                    time: new Date(),
                    code: 'E',
                    location: {
                        lat: coords.lat,
                        lon: coords.lon
                    },
                    ip: coords.ip
                }

                hour.$update(function(success) {
                    success.user = success.user._id;
                    success.date = new Date(success.date);
                    success.clock_in.time = new Date(success.clock_in.time);
                    success.lunch_start.time = new Date(success.lunch_start.time);

                    $scope.clock_hours = success;
                })
            });
        } 
    };

    $scope.LunchEnd = function(user, hour) {
        $scope.lunchEndClicked = true;
        if(!hour) {
            $scope.overrideHoursOperation('lunch_end', user, hour);
        } else {
            if(!hour.lunch_start) {
                $scope.overrideHoursOperation('lunch_end', user, hour);
            } else {
                if($scope.checkMinLunch(hour)) {
                    myCoordinates.get().then(function(coords) {
                        hour.lunch_end = {
                            time: new Date(),
                            code: 'E',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        }

                        hour.$update(function(success) {
                            success.user = success.user._id;
                            success.date = new Date(success.date);
                            success.clock_in.time = new Date(success.clock_in.time);
                            success.lunch_start.time = new Date(success.lunch_start.time);
                            success.lunch_end.time = new Date(success.lunch_end.time);

                            $scope.clock_hours = success;
                        })
                    });
                } else {
                    $scope.lunchEndClicked = false;
                }
            }
        }
    };

    $scope.ClockOut = function(user, hour) {
        $scope.clockOutClicked = true;
        
        if(!hour) {
            $scope.overrideHoursOperation('clock_out', user, hour);
        } else {
            if(!hour.lunch_start) {
                $scope.overrideHoursOperation('clock_out', user, hour);
            } else if(!hour.lunch_end) {
                $scope.overrideHoursOperation('clock_out', user, hour);
            } else {
                myCoordinates.get().then(function(coords) {
                    hour.clock_out = {
                        time: new Date(),
                        code: 'E',
                        location: {
                            lat: coords.lat,
                            lon: coords.lon
                        },
                        ip: coords.ip
                    }

                    hour.$update(function(success) {
                        success.user = success.user._id;
                        success.date = new Date(success.date);
                        success.clock_in.time = new Date(success.clock_in.time);
                        success.lunch_start.time = new Date(success.lunch_start.time);
                        success.lunch_end.time = new Date(success.lunch_end.time);
                        success.clock_out.time = new Date(success.clock_out.time);

                        $scope.clock_hours = success;
                    })
                });
            }
        }
    };

    //this function is called when the foreman does the final
    //submit for the day.  It will check his hours and prompt
    //if time is missing.  Then it will loop through all the
    //tradesmen and check their time and update to foreman's
    //time if missing.
    $scope.finalClockOut = function(foreman_hour) {
        var defer = $q.defer();

        foreman_hour.$update(function(success) {
            $scope.checkTradesmenHours(success);
            defer.resolve('Success');
        });

        return defer.promise;
    };

    $scope.checkTradesmenHours = function(foreman_hour) {
        Hours.query({'start': start,
            'end': end, 
            'type': 'UserDateRange',
            'user': $scope.user._id,
            'trade_code': $scope.my_trade_code,
            'company_code': $scope.user.contractor_code}, function(hours) {
            _.each(hours, function(hour) {
                hour.user = hour.user._id;
            });

            _.each($scope.tradesmen, function(worker) {
                var inlist = $filter('filter')(hours, {'user': worker._id}, true);

                var worker_hour = null;
                var save_new = false;

                if(inlist.length === 0) {
                    save_new = true;
                    worker_hour = new Hours({
                        user: worker._id,
                        date: new Date(),
                        trade_code: $scope.my_trade_code,
                        company_code: $scope.user.contractor_code,
                        clock_in: {
                            time: new Date(foreman_hour.clock_in.time),
                            code: 'F',
                            location: {
                                lat: foreman_hour.clock_in.location.lat,
                                lon: foreman_hour.clock_in.location.lon
                            },
                            ip: foreman_hour.clock_in.ip
                        },
                    });
                } else if(inlist.length === 1) {
                    worker_hour = inlist[0];
                } else {
                    toaster.pop('error', 'Time Card Error', 
                        'Too many hour entries for ' + worker.username);
                }

                if(!worker_hour.lunch_start) {
                    worker_hour.lunch_start = {
                        time: new Date(foreman_hour.lunch_start.time),
                        code: 'F',
                        location: {
                            lat: foreman_hour.lunch_start.location.lat,
                            lon: foreman_hour.lunch_start.location.lon
                        },
                        ip: foreman_hour.lunch_start.ip
                    }
                }

                if(!worker_hour.lunch_end) {
                    worker_hour.lunch_end = {
                        time: new Date(foreman_hour.lunch_end.time),
                        code: 'F',
                        location: {
                            lat: foreman_hour.lunch_end.location.lat,
                            lon: foreman_hour.lunch_end.location.lon
                        },
                        ip: foreman_hour.lunch_end.ip
                    }
                }

                if(!worker_hour.clock_out) {
                    worker_hour.clock_out = {
                        time: new Date(foreman_hour.clock_out.time),
                        code: 'F',
                        location: {
                            lat: foreman_hour.clock_out.location.lat,
                            lon: foreman_hour.clock_out.location.lon
                        },
                        ip: foreman_hour.clock_out.ip
                    }
                }

                if(save_new)
                    worker_hour.$save();
                else
                    worker_hour.$update();
            });
        });
    };

    $scope.overrideHoursOperation = function (caller, user, hours, final_clock_out) {
        var need_in = hours ? false : true; //hours object does not exist so must create
        var need_start = false;
        var need_end = false;
        var need_out = false;

        switch(caller) {
            case 'clock_in':
                break;
            case 'lunch_start':
                need_in = (hours && hours.clock_in)?false:true;
                break;
            case 'lunch_end':
                need_in = (hours && hours.clock_in)?false:true;
                need_start = (hours && hours.lunch_start)?false:true;
                break
            case 'clock_out':
                need_in = (hours && hours.clock_in)?false:true;
                need_start = (hours && hours.lunch_start)?false:true;
                need_end = (hours && hours.lunch_end)?false:true;
                break
            default:
                console.log('unknown case');
        }

        //get the system defined default times for what is needed
        //and set the value for the user here.
        $scope.returnedOptions = {
            hours: hours,
            need_clock_in: need_in,
            need_lunch_start: need_start,
            need_lunch_end: need_end,
            need_clock_out: need_out,
            caller: caller
        };

        ngDialog.openConfirm({
            template: 'foreman/views/tmpl/update-hours.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {

            var hourDoc;

            if(!$scope.returnedOptions.need_clock_in) {
                hourDoc = $scope.returnedOptions.hours;
            }

            myCoordinates.get().then(function(coords) {
                if($scope.returnedOptions.need_clock_in) {
                    hourDoc = new Hours({
                        user: user._id,
                        date: new Date(),
                        trade_code: $scope.my_trade_code,
                        company_code: $scope.user.contractor_code,
                        clock_in: {
                            time: new Date($scope.returnedOptions.hours.clock_in.time),
                            code: 'E',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        }
                    });

                    hourDoc.clock_in.time.setSeconds(0);
                }

                if($scope.returnedOptions.need_lunch_start) {
                    hourDoc.lunch_start = {
                        time: new Date($scope.returnedOptions.hours.lunch_start.time),
                        code: 'E',
                        location: {
                            lat: coords.lat,
                            lon: coords.lon
                        },
                        ip: coords.ip
                    }

                    hourDoc.lunch_start.time.setSeconds(0);
                }

                if($scope.returnedOptions.need_lunch_end) {
                    hourDoc.lunch_end = {
                        time: new Date($scope.returnedOptions.hours.lunch_end.time),
                        code: 'E',
                        location: {
                            lat: coords.lat,
                            lon: coords.lon
                        },
                        ip: coords.ip
                    }

                    hourDoc.lunch_end.time.setSeconds(0);
                }

                if($scope.returnedOptions.need_clock_out) {
                    hourDoc.clock_out = {
                        time: new Date($scope.returnedOptions.hours.clock_out.time),
                        code: 'E',
                        location: {
                            lat: coords.lat,
                            lon: coords.lon
                        },
                        ip: coords.ip
                    }

                    hourDoc.clock_out.time.setSeconds(0);
                }

                //this will set the current date/time to whatever clock button 
                //was clicked
                switch($scope.returnedOptions.caller) {
                    case 'clock_in':
                        break;
                    case 'lunch_start':
                        hourDoc.lunch_start = {
                            time: new Date(),
                            code: 'E',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        }

                        hourDoc.lunch_start.time.setSeconds(0);
                        break;
                    case 'lunch_end':
                        if(!$scope.checkMinLunch($scope.returnedOptions.hours)) {
                            delete $scope.clock_hours.lunch_start;
                            return;
                        }
                        hourDoc.lunch_end = {
                            time: new Date(),
                            code: 'E',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        }

                        hourDoc.lunch_end.time.setSeconds(0);
                        break
                    case 'clock_out':
                        hourDoc.clock_out = {
                            time: new Date(),
                            code: 'E',
                            location: {
                                lat: coords.lat,
                                lon: coords.lon
                            },
                            ip: coords.ip
                        }

                        hourDoc.clock_out.time.setSeconds(0);
                        break
                    default:
                        console.log('unknown case');
                }

                if($scope.returnedOptions.need_clock_in) {
                    //need to create the hours object
                    hourDoc.$save(function(success) {
                        success.date = new Date(success.date);
                        success.clock_in.time = new Date(success.clock_in.time);
                        if(success.lunch_start)
                          success.lunch_start.time = new Date(success.lunch_start.time);
                        if(success.lunch_end)
                          success.lunch_end.time = new Date(success.lunch_end.time);
                        if(success.clock_out)
                          success.clock_out.time = new Date(success.clock_out.time);

                        $scope.clock_hours = success;

                        // if(user === $scope.selectedForeman && final_clock_out === true) {
                        //     $scope.checkTradesmenHours(success);
                        // }
                    });
                } else {
                    //need to update the hours object
                    hourDoc.$update(function(success) {
                        success.date = new Date(success.date);
                        success.clock_in.time = new Date(success.clock_in.time);
                        if(success.lunch_start)
                          success.lunch_start.time = new Date(success.lunch_start.time);
                        if(success.lunch_end)
                          success.lunch_end.time = new Date(success.lunch_end.time);
                        if(success.clock_out)
                          success.clock_out.time = new Date(success.clock_out.time);

                        $scope.clock_hours = success;

                        // if(user === $scope.selectedForeman && final_clock_out === true) {
                        //     $scope.checkTradesmenHours(success);
                        // }
                    });
                }
            });
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/tradesman/public/controllers/tradesman.js